import { MDBBtn, MDBCard, MDBCol, MDBContainer, MDBFooter, MDBNav, MDBNavItem, MDBNavLink, MDBRow, MDBTabContent, MDBTabPane, MDBAlert, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter } from 'mdbreact';
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
// import profile_pic from '../../Assets/blank-profile-picture.png';
// import { Link as RouterLink } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import 'date-fns';
import {
    KeyboardDatePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import axios from '../../authAxios';
import BasicInfoCard from '../BasicInfoCard/BasicInfoCard';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
// import "react-image-gallery/styles/css/image-gallery.css";
// import { styles } from '@material-ui/pickers/views/Calendar/Calendar';
import "./ReviewApplication.css"
import loader from "../../Assets/spinner.gif"
import delete_icon from '../../Assets/delete_icon.svg';

// const brand_color = localStorage.getItem('brand_color')

export class ReviewApplicaton extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color: "",
            activeItem: '',
            modal: false,
            toTrackApplication: false,
            form_obj: {},
            dob: new Date(),
            origin: '',
            nationality: '',
            travelling_to_country: '',
            visa_type: '',
            entry_type: '',
            visa_duration: '',
            applicants: '',
            arrival_dt: '',
            departure_dt: '',
            documents_pool: [],
            doc_img: '',
            application_id: '',
            fileList: [],
            reviewForm: [],
            applicantDoc: [],
            applicantsArr: [],
            //textfield_names//
            company_name: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            father_name: '',
            mother_name: '',
            spouse_name: '',
            birth_place: '',
            email_id: '',
            passport_number: '',
            place_of_issue: '',
            address_line1: '',
            address_line2: '',
            telephone: '',
            city: '',
            local_street: '',
            local_flat_number: '',
            uae_phone_number: '',
            //dropdown_field_names//
            processing: '',
            visa_type: '',
            group_membership: '',
            language_spoken: '',
            gender: '',
            marital_status: '',
            prev_nationality: '',
            present_nationality: '',
            country: '',
            religion: '',
            faith: '',
            education: '',
            profession: '',
            birth_country: '',
            passport_type: '',
            passport_issuing_government: '',
            applicant_loc_outside_uae: '',
            applicant_loc_inside_uae: '',
            applicant_city_inside_uae: '',
            applicant_area_inside_uae: '',
            isSubmitApplication: false,
            applicant_coming_from_country: '',
            //date control
            date_of_birth: '',
            date_of_issue: '', date_of_expiry: '',
            are_you: '',
            who_are_you_travelling_with: '',
            are_you_travelling_with_minor: '',
            minor_name: '',
            evisa_no_of_parent: '',
            dimensions: {
                "width": "90%",
                "height": "50%"
            },
            showReviewFormFieldErr: false,
            errorTextMsg: "",
            applicantsMissingFields: [],
            showMissingFieldModal: false,
            missingFieldsArray: [],
            imageLoad: false,
            applicantsAgreement: [],
            isAgreementChecked: false,
            isNotAllChecked: false,
            showAgreement: false,
            expiryDate: false,
            textField: "",
            showMissingDocModal: false,
            missingDocData: [],
        }
        this.handleTextFieldValueChange = this.handleTextFieldValueChange.bind(this);
        this.handleTextValue = this.handleTextValue.bind(this)
        this.handleDropValue = this.handleDropValue.bind(this)
        this.handleApplicationProceed = this.handleApplicationProceed.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleDateControl = this.handleDateControl.bind(this);
        this.missingFieldToggle = this.missingFieldToggle.bind(this);
        this.handleDeleteApplicantTab = this.handleDeleteApplicantTab.bind(this);
        this.applicantAgreementCheckToggle = this.applicantAgreementCheckToggle.bind(this);
        this.validPassportModal = this.validPassportModal.bind(this)
        this.handleDateFieldValue = this.handleDateFieldValue.bind(this)
        this.handleDateControlError = this.handleDateControlError.bind(this);
    }

    dateFormat = (date) => {
        //console.log(date)
        if ((date === null) || (date === "") || (date === undefined)) {
            return null;
        } else {
            // let temp_arr = date.split("-")
            // let temp_b = temp_arr[0]
            // temp_arr[0] = temp_arr[1]
            // temp_arr[1] = temp_b
            // let d = new Date(temp_arr.join("-"))

            var b = (date).split("-")
            var c = b[2] + "-" + b[1] + "-" + b[0]

            return c;
        }
    }

    missingFieldToggle = () => {
        this.setState({ showMissingFieldModal: !this.state.showMissingFieldModal })
    }

    applicantAgreementCheckToggle = () => {
        this.setState({ isNotAllChecked: !this.state.isNotAllChecked })
    }

    validPassportModal = () => {
        this.setState({ expiryDate: !this.state.expiryDate })
        // localStorage.setItem("validPassport" , "")
    }

    handleTextFieldValueChange(event) {
        // console.log(this.state.reviewForm)

        // console.log(event.target.name)
        // console.log(i)
        // console.log(val)
        // let values = [...this.state.reviewForm];
        if (event.target.value == " ") {
            event.target.value = ""
        }
        this.setState({ textField: event.target.value })
        // //console.log(values)
        // values[i] = event.target.value;
        // console.log(values[i]) 
        var formobj = this.state.form_obj

        formobj[event.target.name] = event.target.value.toUpperCase()
        this.setState({ "form_obj": formobj })
        this.setState({ [event.target.name]: event.target.value.toUpperCase() })
        //console.log({[event.target.name]: event.target.value})
    }

    handleTextValue(card) {
        if (card.value === null) {
            card.value = ""
            if (card.value === "") {
                return this.state.textField[card.name]
            }
        } else {
            return this.state[card.name]
        }
    }

    handleDropValue(card) {
        console.log(card);

        if (card.value === null) {
            card.value = ""
            if (card.value === "") {
                return this.state.textField[card.name]
            }
        } else {
            //console.log(card.name);
            return this.state[card.name]
        }
    }

    handleDateControlError(card) {
        if (card.type === "dateControl" && card.value != null && card.validations.mandatory === true) {
            //console.log(card.value);
            var dob = new Date()
            var dobSplit = (card.value).split("-")
            //console.log(dobSplit);

            dob.setDate(dobSplit[0])
            dob.setMonth(dobSplit[1] - 1)
            //console.log(dob);
            dob.setFullYear(dobSplit[2])
            dob.setHours(0, 0, 0, 0)
            dob = dob.valueOf()
            //console.log(dob);

            var curr_dt = new Date().valueOf()
            //console.log(curr_dt);
            if (card.validations.when === "before") {
                if (curr_dt > dob) {
                    //console.log("current dt is > card dob");
                } else {
                    //console.log("---");
                    return true;
                }
            } else if (card.validations.when === "after") {
                if (curr_dt < dob) {
                    // console.log("current dt is < card dob");
                } else {
                    //console.log("---");
                    return true;
                }
            }
        } else {
            return false;
        }
        return false;
    }

    handleDateFieldValue(card) {
        if (card.value === null) {
            card.value = ""
            if (card.value === "") {
                return this.state.textField[card.name]
            }
        } else {
            return this.state[card.name]
        }
    }

    handleDateControl = (event, name, dateCard) => {
        // console.log(event);
        if (event != null) {
            let dt = new Date(event)
            var dd = (dt.getDate() < 10 ? '0' : '') + dt.getDate();
            var mm = ((dt.getMonth() + 1) < 10 ? '0' : '') + (dt.getMonth() + 1);

            dt = dd + '-' + mm + '-' + dt.getFullYear();
            // console.log(dt);

            if (dateCard.type === "dateControl") {
                var dob = new Date(event).valueOf()
                //console.log(dob);
                var curr_dt = new Date().valueOf()
                //console.log(curr_dt);

                const dateCheck = () => {
                    var formobj = this.state.form_obj
                    formobj[name] = dt
                    var reviewFormObj = this.state.reviewForm
                    reviewFormObj.map((review_form) => {
                        if (name === review_form.name) {
                            review_form.value = dt
                        }
                    })
                    //console.log(reviewFormObj);
                    this.handleDateControlError(reviewFormObj)
                    this.setState({ form_obj: formobj })
                    this.setState({ [name]: dt })
                    this.setState({ dob: dt })
                }

                if (dateCard.validations.when === "before") {
                    if (curr_dt > dob) {
                        dateCheck();
                    } else {
                        //console.log("---");
                        dateCheck();
                    }
                } else if (dateCard.validations.when === "after") {
                    if (curr_dt < dob) {
                        dateCheck();
                    } else {
                        //console.log("---");
                        dateCheck();
                    }
                }
            }
        } else {
            var formobj = this.state.form_obj
            formobj[name] = ""
            this.setState({ form_obj: formobj })
            this.setState({ [name]: "" })
            this.setState({ dob: "" })
        }
    }

    handleDropdownChange(event) {
        var formobj = this.state.form_obj
        //console.log(formobj);
        // console.log(this.state.reviewForm);

        var keys = Object.keys(this.state.form_obj);

        // keys.map((key) => {
        //     // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
        //     // console.log({ [event.target.name]: event.target.value })
        //     // console.log(this.state.form_obj[key]);

        //     if (this.state.form_obj[key] === "ADULT" && key === "who_are_you_travelling_with") {
        //         console.log(">>>> who_are_you_travelling_with");
        //     } else if (this.state.form_obj[key] === "MINOR" && key === "are_you_travelling_with_minor") {
        //         console.log("<<<< are_you_travelling_with_minor");
        //     }
        // })

        formobj[event.target.name] = event.target.value
        //console.log(formobj);
        //this.setState({ [event.target.name]: event.target.value })
        //console.log({ [event.target.name]: event.target.value })

        var reviewFormObj = this.state.reviewForm
        reviewFormObj.map((review_form) => {
            if (event.target.name === review_form.name) {
                review_form.value = event.target.value
            }
            keys.map((key) => {
                if (event.target.name === review_form.dependant_on) {
                    if (this.state.form_obj[key] === event.target.value) {
                        if (review_form.dependant_on) {
                            console.log(review_form);
                            console.log(review_form.name);
                            if (this.state.form_obj.hasOwnProperty(review_form.name)) {
                                if (this.state.form_obj[review_form.name] !== "") {
                                    formobj[review_form.name] = ""
                                    review_form.value = ""
                                    this.state[review_form.name] = ""
                                }
                            }
                        }
                    }
                }
            })
        })
        //console.log(reviewFormObj);
        this.setState({ reviewForm: reviewFormObj })
        this.setState({ "form_obj": formobj })
        // for (var j = 0; j < this.state.reviewForm.length; j++) {
        //     for (var i = 0; i < keys.length; i++) {
        //         var key = keys[i];
        //         //console.log(event.target.name);
        //         if (event.target.name === this.state.reviewForm[j].dependant_on && this.state.form_obj[key] === event.target.value) {
        //             if (this.state.form_obj[key] === "ADULT") {
        //                 formobj['who_are_you_travelling_with'] = ""
        //                 this.setState({ are_you_travelling_with_minor: '', minor_name: '' })
        //                 //console.log(formobj);
        //             } else if (this.state.form_obj[key] === "MINOR") {
        //                 formobj['are_you_travelling_with_minor'] = ""
        //                 this.setState({ who_are_you_travelling_with: '', evisa_no_of_parent: '' })
        //                 //console.log(formobj);
        //             }
        //         }
        //     }
        // }
    }

    handleApplicationProceed() {
        // console.log(this.state.activeItem)
        var keys = Object.keys(this.state.form_obj);
        // console.log(keys)

        // console.log(this.state.reviewForm)
        var missingFields = [];
        var missingFieldsArr = [];
        var new_data = [];


        missingFieldsArr = [
            {
                "applicant_id": this.state.activeItem,
                "applicant_name": this.state.form_obj.first_name + " " + this.state.form_obj.last_name,
                "missing_fields": []
            }
        ]

        //new_data = this.state.missingFieldsArray
        var obj = this.state.missingFieldsArray.find(applicant => applicant.applicant_id === this.state.activeItem)
        if (!obj) {
            //remove existing
            //new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
            new_data = this.state.missingFieldsArray
        } else {
            //new_data = this.state.missingFieldsArray
            const index = this.state.missingFieldsArray.indexOf(obj);
            if (index > -1) {
                this.state.missingFieldsArray.splice(index, 1);
                new_data = this.state.missingFieldsArray
            }
        }

        const missingFieldData = () => {
            var firstName;
            if (this.state.form_obj.first_name) {
                firstName = this.state.form_obj.first_name === null ? "New Applicant" : this.state.form_obj.first_name
            } else {
                firstName = ""
            }
            var lastName = this.state.form_obj.last_name === null ? " " : this.state.form_obj.last_name

            missingFieldsArr = [
                {
                    "applicant_id": this.state.activeItem,
                    "applicant_name": firstName + " " + lastName,
                    "missing_fields": missingFields
                }
            ]
            // console.log("missing", missingFieldsArr);
            // console.log(this.state.missingFieldsArray)
            // console.log(this.state.activeItem)
            // console.log(this.state.applicantsMissingFields);

            var obj = this.state.missingFieldsArray.find(applicant => applicant.applicant_id === this.state.activeItem)
            if (!obj) {
                new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
            } else {
                new_data = this.state.missingFieldsArray
            }
        }

        for (var j = 0; j < this.state.reviewForm.length; j++) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key === this.state.reviewForm[j].name && this.state.reviewForm[j].validations.mandatory === true && this.state.reviewForm[j].validations.display === true && this.state.form_obj[key] !== null) {
                    //console.log("Key: " + key + "     Value = " + this.state.form_obj[key])
                    if (this.state.form_obj[key] === "" || this.state.form_obj[key].includes('NaN') || this.state.form_obj[key] === "1-1-1970") {
                        //alert(key + " is required")                    
                        // console.table('Key : ' + key, 'Value : ' + this.state.form_obj[key])
                        //this.setState({showReviewFormFieldErr:true,errorTextMsg: this.state.reviewForm[j].label + " is required"})
                        //console.log(this.state.form_obj)
                        // console.log("if statement worked >>>>>>" + i)

                        if (!this.state.reviewForm[j].dependant_on) {
                            //console.log(this.state.reviewForm[j].label);
                            missingFields.push(this.state.reviewForm[j].label)
                            // console.log("Last Name",this.state.form_obj.last_name);
                            missingFieldData();
                        }

                        //break;                    
                    } else {
                        // console.log("else statement worked >>>>>>" + i)
                        //console.log("else statement worked >>>>>>");
                        if (this.state.reviewForm[j].type === "dateControl") {
                            //console.table('Key : ' + key, 'Value : ' + this.state.form_obj[key])
                            //console.log(this.state.form_obj[key]);
                            var dob = new Date()
                            var dobSplit = (this.state.form_obj[key]).split("-")
                            //console.log(dobSplit);

                            dob.setDate(dobSplit[0])
                            dob.setMonth(dobSplit[1] - 1)
                            dob.setFullYear(dobSplit[2])
                            dob.setHours(0, 0, 0, 0)
                            dob = dob.valueOf()
                            //console.log(dob);

                            const applicantsDateField = () => {
                                missingFields.push(this.state.reviewForm[j].label)
                                missingFieldData();
                            }
                            var curr_dt = new Date()
                            //console.log(curr_dt.setFullYear(curr_dt.getFullYear() - 25));

                            var cur_dt = new Date().valueOf();
                            //console.log(cur_dt);

                            if (this.state.reviewForm[j].validations.when === "before") {
                                if (this.state.reviewForm[j].name === "date_of_issue") {
                                    if (cur_dt > dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 25) < dob)) {
                                        //console.log("current dt is > this.state.reviewForm[j]");
                                    } else {
                                        //console.log("ELSEIF---");
                                        applicantsDateField();
                                    }
                                } else if (this.state.reviewForm[j].name === "date_of_birth") {
                                    if (cur_dt > dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 120) < dob)) {
                                        //console.log("current dt is > this.state.reviewForm[j]");
                                    } else {
                                        //console.log("ELSEIF---");
                                        applicantsDateField();
                                    }
                                }
                                else {
                                    if (cur_dt > dob) {
                                        //console.log("current dt is > this.state.reviewForm[j]");
                                    } else {
                                        applicantsDateField();
                                    }
                                }
                            } else if (this.state.reviewForm[j].validations.when === "after") {
                                if (this.state.reviewForm[j].name === "date_of_expiry") {
                                    if (cur_dt < dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 25) < dob)) {
                                        //console.log("current dt is < this.state.reviewForm[j]");
                                    } else {
                                        //console.log("ELSEIF---");
                                        applicantsDateField();
                                    }
                                } else {
                                    if (cur_dt < dob) {
                                        //console.log("current dt is < this.state.reviewForm[j]");
                                    } else {
                                        applicantsDateField();
                                    }
                                }
                            }
                        }
                    }
                    var obj = this.state.reviewForm.filter((r) => r.dependant_on === key)
                    //console.log(obj);

                    if (obj.length !== 0) {
                        obj.map((o) => {
                            if (o.dependant_value === this.state.form_obj[key]) {
                                // console.log(">>>>> " + o.dependant_value);
                                // console.log(">>>>> " + key);
                                // console.log(">>>>> " + o.name);
                                if (this.state.form_obj.hasOwnProperty(o.name)) {
                                    // console.log(this.state.form_obj[o.name]);
                                    // console.table('Key : ' + o.name, 'Value : ' + this.state.form_obj[o.name])
                                    if (this.state.form_obj[o.name] === "") {
                                        if (o.validations.mandatory) {
                                            //console.log(o.label);
                                            missingFields.push(o.label)
                                            missingFieldData();
                                        }
                                    }
                                }
                            }
                        })
                    }
                } else if (key === this.state.reviewForm[j].name && this.state.reviewForm[j].validations.mandatory === false && this.state.reviewForm[j].validations.display === true && this.state.form_obj[key] !== null) {
                    var obj = this.state.reviewForm.filter((r) => r.dependant_on === key)
                    //console.log(obj);

                    if (obj.length !== 0) {
                        obj.map((o) => {
                            if (o.dependant_value === this.state.form_obj[key]) {
                                // console.log(">>>>> " + o.dependant_value);
                                // console.log(">>>>> " + key);
                                // console.log(">>>>> " + o.name);
                                if (this.state.form_obj.hasOwnProperty(o.name)) {
                                    // console.log(this.state.form_obj[o.name]);
                                    // console.table('Key : ' + o.name, 'Value : ' + this.state.form_obj[o.name])
                                    if (this.state.form_obj[o.name] === "") {
                                        if (o.validations.mandatory) {
                                            //console.log(o.label);
                                            missingFields.push(o.label)
                                            missingFieldData();
                                        }
                                    }
                                }
                            }
                        })
                    }
                }
            }
        }
        var isNotAllChecked = false;
        // console.log(this.state.applicantsAgreement)
        this.state.applicantsAgreement.map((app_agreement) => {
            // console.log(app_agreement.isAgreementChecked)
            if (app_agreement.isAgreementChecked !== true) {
                isNotAllChecked = true;
            }
        })
        console.log(this.state.form_obj)
        console.log(new_data)
        console.log(this.state.missingFieldsArray)
        if (isNotAllChecked === true) {
            this.applicantAgreementCheckToggle()
        } else if (new_data.length > 0) {
            this.missingFieldToggle()
            this.setState({ applicantsMissingFields: new_data })
            // console.log(this.state.applicantsMissingFields)
        } else {
            axios
                .post('/visa/saveApplicantVisaForm', {
                    "applicant_id": this.state.activeItem,
                    "visa_form_obj": this.state.form_obj
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then(res => {
                    //console.log(res);
                    //console.log("-----------")
                    if (!localStorage.getItem("validPassport")) {
                        // this.setState({ isSubmitApplication: true })
                        this.api_getMissingDocsList()
                    }
                    //console.log("application submitted...")
                }).
                catch(err => {
                    console.log(err);
                })
        }
        if (localStorage.getItem("validPassport")) {
            this.setState({ expiryDate: true })
        }
    }
    api_getMissingDocsList() {
        var applicantJsonArray = []
        for (var index in this.state.applicantsArr) {
            var applicant = this.state.applicantsArr[index]
            var obj = {
                "applicant_id": applicant._id
            }
            applicantJsonArray.push(obj)

        }
        if (applicantJsonArray.length === 0) {
             
        }
        axios
            .post('/visa/getMissingDocumentsForApplication', {
                "application_id": localStorage.getItem('application_id'),
                "user_id": localStorage.getItem('user_id'),
                "applicants": applicantJsonArray
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                if (res.data.data === "success"){
                    var missings = res.data.dataobj
                    if (missings.length > 0) {
                        var b = []
                        missings.map((missing) => {
                            var a = missing.replace("null", " ")
                            b.push(a)
                        })
                        console.log("missing", b);
                        this.setState({ missingDocData: b })

                        this.missingDocToggle()
                    }else{
                        this.setState({ isSubmitApplication: true })
                    }
                }else{

                }
            })
            .catch(err => {
                // console.log(err);
            })
    }
    missingDocToggle = () => {
        this.setState({ showMissingDocModal: !this.state.showMissingDocModal })
    }
    handle_missing_doc_ok = ()=>{
        this.setState({ showMissingDocModal: false })
        this.setState({isMissingDocuments:true})
    }
    renderFields = (card, index) => {
        //console.log(card.validations.format)    
        //console.log(card);
        //console.log(this.state.form_obj);

        var keys = Object.keys(this.state.form_obj);

        if (card.name === "date_of_expiry" && card.value != null) {
            // console.log(card);
            // var date = new Date()

            // console.log("EXPIRY DATE", card.value);

            localStorage.setItem("validPassport", "")

            // const formattedDate = (inputFormat) =>{
            //     function pad(s) { return (s < 10) ? '0' + s : s; }
            //     var d = new Date(inputFormat)
            //     return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
            // }

            // var a = formattedDate(date)
            // var b = (card.value).replace(/-/g,"/")
            var b = (card.value).split("-")
            var c = b[2] + "-" + b[1] + "-" + b[0]

            // console.log("Today Date", a);
            // console.log("Expiry Date",  c );

            var valid = false
            if (new Date().getTime() > new Date(c).getTime()) {
                // alert("true")
                //console.log("Your Passport has expired!")
                valid = true
                localStorage.setItem("validPassport", valid)
            }
        }

        const textfieldRender = () => {
            return (
                (card.type === "textField" && !card.dependant_on) &&
                <MDBCol size="12" lg="4" className="">
                    <>
                        <small>{card.label}</small><br />
                        <TextField
                            className="w-100 mb-3"
                            name={card.name}
                            disabled={card.validations.read_only === true}
                            error={this.handleTextValue(card) == "" && card.validations.mandatory}
                            onChange={(e) => this.handleTextFieldValueChange(e)}
                            value={this.handleTextValue(card)}
                        />
                    </>
                </MDBCol>
            )
        }

        const dropdownFieldRender = () => {
            return (
                (card.type === "dropdown" && !card.dependant_on) &&
                <MDBCol size="12" lg="4" className="">

                    <>
                        <small>{card.label}</small>
                        <Select
                            id={card.name}
                            className="w-100 mb-3 text-left"
                            name={card.name}
                            value={card.value}
                            error={card.value == "" && card.validations.mandatory}
                            disabled={card.validations.read_only === true}
                            onChange={this.handleDropdownChange}
                        //onChange={(e)=> {this.handleDropdownChange(e,index)}}
                        >
                            {card.options.map((opt) =>
                                <MenuItem value={opt} key={opt}>{opt}</MenuItem>
                            )
                            }
                        </Select>
                    </>
                </MDBCol>
            )
        }

        const datecontrolField = () => {
            return (
                (card.type === "dateControl" && !card.dependant_on) &&
                <MDBCol size="12" lg="4" className="">
                    <>
                        <small>{card.label}</small>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                // disableToolbar
                                className="w-100 mb-3"
                                variant="inline"
                                format="dd-MM-yyyy"
                                //margin="normal"
                                id={card.name}
                                //label={card.label}
                                error={this.handleDateControlError(card) || (this.handleDateFieldValue(card) == "" && card.validations.mandatory)}
                                value={this.dateFormat(this.handleDateFieldValue(card))}
                                disabled={card.validations.read_only === true}
                                //onChange={(e)=> {this.handleDateControl(this,index)}}
                                onChange={(e) => this.handleDateControl(e, card.name, card)}
                                style={{ width: '100%' }}
                                autoOk
                                InputProps={{ readOnly: true }}

                            />
                        </MuiPickersUtilsProvider>
                    </>
                </MDBCol>
            )
        }

        const renderConditionalFields = () => {
            return (
                keys.map((key) => {
                    //console.log(key);
                    if (card.type === "dropdown" && card.dependant_on) {
                        // console.log(card.dependant_value);
                        // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
                        // console.log(card.dependant_on);
                        // console.log(card.name);
                        if (key === card.dependant_on && this.state.form_obj[key] === card.dependant_value) {
                            //console.log(card.label);
                            return (
                                <MDBCol size="12" lg="4" className="">
                                    <>
                                        <small>{card.label}</small>
                                        <Select
                                            id={card.name}
                                            className="w-100 mb-3 text-left"
                                            name={card.name}
                                            value={card.value}
                                            error={card.value == "" && card.validations.mandatory}
                                            disabled={card.validations.read_only === true}
                                            onChange={this.handleDropdownChange}
                                        //onChange={(e)=> {this.handleDropdownChange(e,index)}}
                                        >
                                            {card.options.map((opt) =>
                                                <MenuItem value={opt} key={opt}>{opt}</MenuItem>
                                            )
                                            }
                                        </Select>
                                    </>
                                </MDBCol>
                            );
                        }
                    } else if (card.type === "textField" && card.dependant_on) {
                        // console.log(card.dependant_value);
                        // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
                        // console.log(card.dependant_on);
                        // console.log(card.name);
                        if (key === card.dependant_on && this.state.form_obj[key] === card.dependant_value) {
                            //console.log(card.label);
                            return (
                                <MDBCol size="12" lg="4" className="">
                                    <>
                                        <small>{card.label}</small><br />
                                        <TextField
                                            className="w-100 mb-3"
                                            name={card.name}
                                            disabled={card.validations.read_only === true}
                                            error={this.handleTextValue(card) == "" && card.validations.mandatory}
                                            onChange={(e) => this.handleTextFieldValueChange(e)}
                                            value={this.handleTextValue(card)}
                                        />
                                    </>
                                </MDBCol>
                            );
                        }
                    } else if (card.type === "dateControl" && card.dependant_on) {
                        // console.log(card.dependant_value);
                        // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
                        // console.log(card.dependant_on);
                        // console.log(card.name);
                        if (key === card.dependant_on && this.state.form_obj[key] === card.dependant_value) {
                            //console.log(card.label);
                            return (
                                <MDBCol size="12" lg="4" className="">
                                    <>
                                        <small>{card.label}</small>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                // disableToolbar
                                                className="w-100 mb-3"
                                                variant="inline"
                                                format="dd-MM-yyyy"
                                                //margin="normal"
                                                id={card.name}
                                                //label={card.label}
                                                error={this.handleDateControlError(card) || (this.handleDateFieldValue(card) == "" && card.validations.mandatory)}
                                                value={this.dateFormat(this.handleDateFieldValue(card))}
                                                disabled={card.validations.read_only === true}
                                                //onChange={(e)=> {this.handleDateControl(this,index)}}
                                                onChange={(e) => this.handleDateControl(e, card.name, card)}
                                                style={{ width: '100%' }}
                                                autoOk
                                                InputProps={{ readOnly: true }}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </>
                                </MDBCol>
                            );
                        }
                    }
                })
            )
        }

        if (card.validations.display) {
            return (
                <>
                    {textfieldRender()}
                    {dropdownFieldRender()}
                    {renderConditionalFields()}
                    {datecontrolField()}
                </>
                // <MDBCol size="12" lg="4" className="">
                //     {/* <div key={card.name}>
                //         <label key={"review_form_" + card.name} htmlFor={card.name}>
                //             {card.label}
                //         </label>
                //         <input 
                //             ref={(key) => {this[card.name] = key}}
                //             type={card.type}
                //             key={"form_" + card.name}
                //             value={card.value}
                //             onChange={(e)=> {this.handleTextFieldValueChange(e,card.name)}}
                //         />

                //     </div> */}
                //     {(card.type === "textField" && !card.dependant_on) &&
                //         <>
                //             <small>{card.label}</small><br />
                //             <TextField
                //                 error={this.handleTextValue(card) == "" && card.validations.mandatory}
                //                 className="w-100 mb-3"
                //                 name={card.name}
                //                 disabled={card.validations.read_only === true}
                //                 onChange={this.handleTextFieldValueChange}
                //                 value={this.handleTextValue(card)}
                //             />
                //         </>
                //     }
                //     {(card.type === "dropdown" && !card.dependant_on) &&
                //         <>
                //             {/* {card.dependant_value === this.state.form_obj} */}
                //             <small>{card.label}</small>
                //             <Select
                //                 id={card.name}
                //                 error={this.handleDropValue(card) == "" && card.validations.mandatory}
                //                 className="w-100 mb-3 text-left"
                //                 name={card.name}
                //                 disabled={card.validations.read_only === true}
                //                 value={this.handleDropValue(card)}
                //                 onChange={this.handleDropdownChange}
                //             //onChange={(e)=> {this.handleDropdownChange(e,index)}}
                //             >
                //                 {card.options.map((opt) =>
                //                     <MenuItem value={opt} key={opt}>{opt}</MenuItem>
                //                 )
                //                 }
                //             </Select>
                //         </>
                //     }
                //     {keys.map((key) => {
                //         //console.log(key);
                //         if (card.type === "dropdown" && card.dependant_on) {
                //             // console.log(card.dependant_value);
                //             // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
                //             // console.log(card.dependant_on);
                //             // console.log(card.name);
                //             if (key === card.dependant_on && this.state.form_obj[key] === card.dependant_value) {
                //                 //console.log(card.label);
                //                 return (
                //                     <>
                //                         <small>{card.label}</small>
                //                         <Select
                //                             id={card.name}
                //                             error={this.handleDropValue(card) == "" && card.validations.mandatory}
                //                             className="w-100 mb-3 text-left"
                //                             name={card.name}
                //                             disabled={card.validations.read_only === true}
                //                             value={this.handleDropValue(card)}
                //                             onChange={this.handleDropdownChange}
                //                         //onChange={(e)=> {this.handleDropdownChange(e,index)}}
                //                         >
                //                             {card.options.map((opt) =>
                //                                 <MenuItem value={opt} key={opt}>{opt}</MenuItem>
                //                             )
                //                             }
                //                         </Select>
                //                     </>
                //                 );
                //             }
                //         } else if (card.type === "textField" && card.dependant_on) {
                //             // console.log(card.dependant_value);
                //             // console.log("Key: " + key + " Value: " + this.state.form_obj[key])
                //             // console.log(card.dependant_on);
                //             // console.log(card.name);
                //             if (key === card.dependant_on && this.state.form_obj[key] === card.dependant_value) {
                //                 //console.log(card.label);
                //                 return (
                //                     <>
                //                         <small>{card.label}</small><br />
                //                         <TextField
                //                             error={this.handleTextValue(card) == "" && card.validations.mandatory}
                //                             className="w-100 mb-3"
                //                             name={card.name}
                //                             disabled={card.validations.read_only === true}
                //                             onChange={this.handleTextFieldValueChange}
                //                             value={this.handleTextValue(card)}
                //                         />
                //                     </>
                //                 );
                //             }
                //         }
                //     })

                //     }
                //     {/* {(card.type === "dropdown" && card.dependant_on === "are_you") &&
                //         <>
                //             <small>{card.label}</small>
                //             <Select
                //                 id={card.name}
                //                 error={this.handleDropValue(card) == "" && card.validations.mandatory}
                //                 className="w-100 mb-3 text-left"
                //                 name={card.name}
                //                 disabled={card.validations.read_only === true}
                //                 value={this.handleDropValue(card)}
                //                 onChange={this.handleDropdownChange}
                //             //onChange={(e)=> {this.handleDropdownChange(e,index)}}
                //             >
                //                 {card.options.map((opt) =>
                //                     <MenuItem value={opt} key={opt}>{opt}</MenuItem>
                //                 )
                //                 }
                //             </Select>
                //         </>
                //     } */}
                //     {card.type === "dateControl" &&
                //         <>
                //             <small>{card.label}</small>
                //             <MuiPickersUtilsProvider utils={DateFnsUtils}>
                //                 <KeyboardDatePicker
                //                     // disableToolbar
                //                     variant="inline"
                //                     format="dd-MM-yyyy"
                //                     //margin="normal"
                //                     id={card.name}
                //                     disabled={card.validations.read_only === true}
                //                     //label={card.label}
                //                     error={this.handleDateControlError(card) || (this.handleDateFieldValue(card) == "" && card.validations.mandatory)}
                //                     value={this.dateFormat(this.handleDateFieldValue(card))}
                //                     //onChange={(e)=> {this.handleDateControl(this,index)}}
                //                     onChange={(e) => this.handleDateControl(e, card.name, card)}
                //                     className="w-100 mb-3"
                //                     autoOk
                //                     InputProps={{ readOnly: true }}
                //                 />
                //             </MuiPickersUtilsProvider>
                //         </>
                //     }
                // </MDBCol>

            )

        }

    }

    toggle = tab => e => {
        // console.log("--------- in toggle ");

        // console.log(this.state.activeItem);
        // console.log(tab);

        // console.log("---------");

        this.setState({ imageLoad: true })
        if (this.state.activeItem !== tab) {
            //console.log(this.state.form_obj)
            var keys = Object.keys(this.state.form_obj);
            //console.log(keys)

            // console.log(this.state.reviewForm)
            var missingFields = [];
            var missingFieldsArr = [];
            var new_data = [];

            var obj = this.state.missingFieldsArray.find(applicant => applicant.applicant_id === this.state.activeItem)
            if (!obj) {
                //remove existing
                //new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
                new_data = this.state.missingFieldsArray
            } else {
                //new_data = this.state.missingFieldsArray
                const index = this.state.missingFieldsArray.indexOf(obj);
                if (index > -1) {
                    this.state.missingFieldsArray.splice(index, 1);
                    new_data = this.state.missingFieldsArray
                }
            }

            const missingFieldData = () => {
                var firstName;
                if (this.state.form_obj.first_name) {
                    firstName = this.state.form_obj.first_name === null ? "New Applicant" : this.state.form_obj.first_name
                } else {
                    firstName = ""
                }

                var lastName = this.state.form_obj.last_name === null ? " " : this.state.form_obj.last_name

                missingFieldsArr = [
                    {
                        "applicant_id": this.state.activeItem,
                        "applicant_name": firstName + " " + lastName,
                        "missing_fields": missingFields
                    }
                ]
                //break;
                // console.log(tab)
                // console.log(this.state.missingFieldsArray)

                var obj = this.state.missingFieldsArray.find(applicant => applicant.applicant_id === this.state.activeItem)
                if (!obj) {
                    new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
                } else {
                    new_data = this.state.missingFieldsArray
                }
            }

            for (var j = 0; j < this.state.reviewForm.length; j++) {
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if (key === this.state.reviewForm[j].name && this.state.reviewForm[j].validations.mandatory === true && this.state.reviewForm[j].validations.display === true && this.state.form_obj[key] !== null) {
                        // console.log("Key: " + key + "     Value = " + this.state.form_obj[key])
                        if (this.state.form_obj[key] === "" || this.state.form_obj[key].includes('NaN') || this.state.form_obj[key] === "1-1-1970" || this.state.form_obj[key] === "01-01-1970") {
                            //alert(key + " is required")                    
                            // console.table('Key : ' + key, 'Value : ' + this.state.form_obj[key])
                            //this.setState({showReviewFormFieldErr:true,errorTextMsg: this.state.reviewForm[j].label + " is required"})
                            //console.log(this.state.reviewForm[j].label)
                            // console.log("if statement worked >>>>>>" + i)

                            if (!this.state.reviewForm[j].dependant_on) {
                                //console.log(this.state.reviewForm[j].label);
                                missingFields.push(this.state.reviewForm[j].label)
                                missingFieldData();
                                // new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
                            }
                        } else {
                            // console.log("else statement worked >>>>>>" + i)
                            if (this.state.reviewForm[j].type === "dateControl") {
                                //console.table('Key : ' + key, 'Value : ' + this.state.form_obj[key])
                                //console.log(this.state.form_obj[key]);
                                var dob = new Date()
                                var dobSplit = (this.state.form_obj[key]).split("-")
                                //console.log(dobSplit);

                                dob.setDate(dobSplit[0])
                                dob.setMonth(dobSplit[1] - 1)
                                dob.setFullYear(dobSplit[2])
                                dob.setHours(0, 0, 0, 0)
                                dob = dob.valueOf()
                                //console.log(dob);

                                const applicantsDateField = () => {
                                    missingFields.push(this.state.reviewForm[j].label)
                                    missingFieldData();
                                }
                                var curr_dt = new Date()
                                //console.log(curr_dt.setFullYear(curr_dt.getFullYear() - 25));

                                var cur_dt = new Date().valueOf();
                                //console.log(cur_dt);

                                if (this.state.reviewForm[j].validations.when === "before") {
                                    if (this.state.reviewForm[j].name === "date_of_issue") {
                                        if (cur_dt > dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 25) < dob)) {
                                            //console.log("current dt is > this.state.reviewForm[j]");
                                        } else {
                                            //console.log("ELSEIF---");
                                            applicantsDateField();
                                        }
                                    } else if (this.state.reviewForm[j].name === "date_of_birth") {
                                        if (cur_dt > dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 120) < dob)) {
                                            //console.log("current dt is > this.state.reviewForm[j]");
                                        } else {
                                            //console.log("ELSEIF---");
                                            applicantsDateField();
                                        }
                                    }
                                    else {
                                        if (cur_dt > dob) {
                                            //console.log("current dt is > this.state.reviewForm[j]");
                                        } else {
                                            applicantsDateField();
                                        }
                                    }
                                } else if (this.state.reviewForm[j].validations.when === "after") {
                                    if (this.state.reviewForm[j].name === "date_of_expiry") {
                                        if (cur_dt < dob && (curr_dt.setFullYear(curr_dt.getFullYear() - 25) < dob)) {
                                            //console.log("current dt is < this.state.reviewForm[j]");
                                        } else {
                                            //console.log("ELSEIF---");
                                            applicantsDateField();
                                        }
                                    } else {
                                        if (cur_dt < dob) {
                                            //console.log("current dt is < this.state.reviewForm[j]");
                                        } else {
                                            applicantsDateField();
                                        }
                                    }
                                }
                            }
                        }
                        var obj = this.state.reviewForm.filter((r) => r.dependant_on === key)
                        //console.log(obj);

                        if (obj.length !== 0) {
                            obj.map((o) => {
                                if (o.dependant_value === this.state.form_obj[key]) {
                                    // console.log(">>>>> " + o.dependant_value);
                                    // console.log(">>>>> " + key);
                                    // console.log(">>>>> " + o.name);
                                    if (this.state.form_obj.hasOwnProperty(o.name)) {
                                        // console.log(this.state.form_obj[o.name]);
                                        // console.table('Key : ' + o.name, 'Value : ' + this.state.form_obj[o.name])
                                        if (this.state.form_obj[o.name] === "") {
                                            if (o.validations.mandatory) {
                                                //console.log(o.label);
                                                missingFields.push(o.label)
                                                missingFieldData();
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    } else if (key === this.state.reviewForm[j].name && this.state.reviewForm[j].validations.mandatory === false && this.state.reviewForm[j].validations.display === true && this.state.form_obj[key] !== null) {
                        var obj = this.state.reviewForm.filter((r) => r.dependant_on === key)
                        //console.log(obj);

                        if (obj.length !== 0) {
                            obj.map((o) => {
                                if (o.dependant_value === this.state.form_obj[key]) {
                                    // console.log(">>>>> " + o.dependant_value);
                                    // console.log(">>>>> " + key);
                                    // console.log(">>>>> " + o.name);
                                    if (this.state.form_obj.hasOwnProperty(o.name)) {
                                        // console.log(this.state.form_obj[o.name]);
                                        // console.table('Key : ' + o.name, 'Value : ' + this.state.form_obj[o.name])
                                        if (this.state.form_obj[o.name] === "") {
                                            if (o.validations.mandatory) {
                                                //console.log(o.label);
                                                missingFields.push(o.label)
                                                missingFieldData();
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    }
                }
            }
            // console.log(this.state.form_obj)
            // console.log(this.state.applicantsAgreement)
            // console.log(new_data)
            //console.log(this.state.isAgreementChecked)
            this.state.applicantsAgreement.map((m) => {
                // console.log(m.applicant_id)
                // console.log(this.state.activeItem)
                if (this.state.activeItem !== m.applicant_id) {
                    //m.isAgreementChecked = !this.state.isAgreementChecked
                    // console.log(m.isAgreementChecked)
                    this.setState({ isAgreementChecked: m.isAgreementChecked })
                }
            })
            // console.log(this.state.applicantsAgreement)

            this.setState({ missingFieldsArray: new_data })
            this.setState({ applicantsMissingFields: new_data })
            //this.setState({isAgreementChecked : !this.state.isAgreementChecked  })

            this.setState({
                activeItem: tab
            });
            // console.log("in review app toggle .........." + tab)
            //Save old form data before getting new tab data
            var last_applicant_id = localStorage.getItem("applicant_id")
            //console.log("-----OLD FORM DATA------")
            axios
                .post('/visa/saveApplicantVisaForm', {
                    "applicant_id": last_applicant_id,
                    "visa_form_obj": this.state.form_obj
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then(res => {
                    //console.log(res);
                    //console.log("-----------")

                }).catch(err => {
                    console.log(err);
                })
            //now getting new tab data
            this.getApplicantReviewForm(tab)
            this.getApplicantDocData(tab)
        }

    };

    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleSelect = (e) => {
        this.setState({ selection: e.target.value })
        //console.log(this.state.selection)
    }

    handleAgreementChecked = () => {
        // console.log(this.state.activeItem)
        // console.log(this.state.applicantsAgreement)
        //this.setState({isAgreementChecked : !this.state.isAgreementChecked  })
        // console.log("agreement checked ===>" + !this.state.isAgreementChecked);

        this.state.applicantsAgreement.map((m) => {
            // console.log(m.applicant_id)
            if (this.state.activeItem === m.applicant_id) {
                this.setState({ isAgreementChecked: !this.state.isAgreementChecked })
                m.isAgreementChecked = !this.state.isAgreementChecked
            }
        })
        // console.log(this.state.applicantsAgreement)
    }

    handleDeleteApplicantTab(applicantId) {
        this.setState({ imageLoad: false })
        // console.log("applicant_id ===" + applicantId);
        // console.log("activeItem ===" + this.state.activeItem)

        if (this.state.applicantsArr.length === 1) {
            this.setState({
                showReviewFormFieldErr: true,
                errorTextMsg: 'Atleast one applicant is mandatory',
            })
            setTimeout(() => {
                this.setState({ showReviewFormFieldErr: false })
            }, 2000)
            return
        }
        axios
            .post('/visa/deleteApplicantFromApplication',
                {
                    "application_id": localStorage.getItem('application_id'),
                    "user_id": localStorage.getItem('user_id'),
                    "applicant_id": this.state.activeItem
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                //console.log(res);
                //this.setState({dataObj: res.data.dataobj})
                if (res.data.data === "success") {
                    axios
                        .post('/visa/getApplicationApplicantsDetails', {
                            "application_id": localStorage.getItem('application_id')
                        },
                            {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                        .then(res => {
                            //console.log(res);
                            // console.log("setting new active item [0] index >>>>>>>> " + res.data.dataobj.applicants[0]._id);
                            // console.log("missing fields array >>>>>>>> " + JSON.stringify(this.state.missingFieldsArray));
                            // console.log("applicants missing fields array >>>>>>>> " + JSON.stringify(this.state.applicantsMissingFields));

                            //this.setState({documents_pool: res.data.dataobj.application.documents_pool})
                            this.setState({ applicantsArr: res.data.dataobj.applicants })
                            // console.log("applicant" , res.data.dataobj.applicants);
                            // console.log(">>>>>>>>>> " + JSON.stringify(this.state.applicantsArr))
                            //this.setState({"activeItem":this.state.dataObj._id})
                            // console.log("----- " + applicantId)
                            this.getApplicantReviewForm(res.data.dataobj.applicants[0]._id)
                            this.getApplicantDocData(res.data.dataobj.applicants[0]._id)
                            //console.log(res.data.dataobj.application.documents_pool)

                            var new_data = [];

                            //new_data = this.state.missingFieldsArray
                            var obj = this.state.missingFieldsArray.find(applicant => applicant.applicant_id === this.state.activeItem)
                            //console.log("obj >>>>>>>>>>>> " + JSON.stringify(obj));

                            if (!obj) {
                                //remove existing
                                //new_data = this.state.missingFieldsArray.concat(missingFieldsArr)
                                new_data = this.state.missingFieldsArray
                            } else {
                                //new_data = this.state.missingFieldsArray
                                const index = this.state.missingFieldsArray.indexOf(obj);
                                //console.log("index of obj >>>>>>> " + index);

                                if (index > -1) {
                                    this.state.missingFieldsArray.splice(index, 1);
                                    new_data = this.state.missingFieldsArray
                                }
                            }
                            //console.log("<<<< applicant_id === applicantId >>>> " + JSON.stringify(new_data));

                            this.setState({ activeItem: res.data.dataobj.applicants[0]._id, applicantsMissingFields: new_data })

                            //////////////////////////////////////

                            var app_agreement = [];
                            this.state.applicantsArr.map((app_arr) => {
                                // console.log(app_arr._id)
                                var applicants_Agreement =
                                {
                                    "applicant_id": app_arr._id,
                                    "isAgreementChecked": this.state.isAgreementChecked
                                }
                                app_agreement.push(applicants_Agreement)
                                // console.log(applicants_Agreement.isAgreementChecked)
                                this.setState({ isAgreementChecked: applicants_Agreement.isAgreementChecked })
                            })
                            // console.log(app_agreement)
                            this.setState({ applicantsAgreement: app_agreement })


                        })
                        .catch(err => {
                            console.log(err);
                        })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    handleReviewFormSave() {
        //console.log("saving review form in draft...");
        var current_Tab_Applicant_Id = localStorage.getItem("applicant_id")
        //console.log(current_Tab_Applicant_Id);

        axios
            .post('/visa/saveApplicantVisaForm', {
                "applicant_id": current_Tab_Applicant_Id,
                "visa_form_obj": this.state.form_obj
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                //console.log(res);
                //console.log("-----------")
                this.setState({ toTrackApplication: true })

            }).catch(err => {
                console.log(err);
            })
    }

    componentDidMount() {
        this.setState({ brand_color: localStorage.getItem("brand_color") })
        this.setState({
            dimensions: {
                width: document.getElementById('footerRow').offsetWidth,
                height: 0,
            },
        });
        setTimeout(() => {
            axios
                .post('/visa/generateRPAImagesForAllApplicants', {
                    "application_id": localStorage.getItem('application_id')
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then(res => {
                })
                .catch(err => {
                    console.log(err);
                })
            axios
                .post('/visa/getApplicationApplicantsDetails', {
                    "application_id": localStorage.getItem('application_id')
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then(res => {
                    //console.log(res);
                    // this.setState({isOrganiseApplication: true}) 
                    // localStorage.setItem('application_id',res.data.dataobj._id)     
                    //console.log(res.data.dataobj.application.nationality)
                    var { origin, nationality, travelling_to_country, visa_type, entry_type, visa_duration, applicants, arrival_dt, departure_dt } = this.state;

                    origin = res.data.dataobj.application.origin
                    nationality = res.data.dataobj.application.nationality
                    travelling_to_country = res.data.dataobj.application.travelling_to_country
                    visa_type = localStorage.getItem('visa_type')
                    entry_type = localStorage.getItem('entry_type')
                    visa_duration = res.data.dataobj.application.total_days
                    applicants = localStorage.getItem('applicants')
                    arrival_dt = res.data.dataobj.application.journey_start_date
                    departure_dt = res.data.dataobj.application.journey_end_date

                    this.setState({ origin, nationality, travelling_to_country, visa_type, entry_type, visa_duration, applicants, arrival_dt, departure_dt })
                    this.setState({ documents_pool: res.data.dataobj.application.documents_pool })
                    this.setState({ applicantsArr: res.data.dataobj.applicants })
                    //console.log(this.state.applicantsArr[0]._id)
                    this.setState({ activeItem: this.state.applicantsArr[0]._id })


                    this.getApplicantReviewForm(this.state.applicantsArr[0]._id)
                    this.getApplicantDocData(this.state.applicantsArr[0]._id)
                    var app_agreement = [];
                    this.state.applicantsArr.map((app_arr) => {
                        // console.log(app_arr._id)
                        var applicants_Agreement =
                        {
                            "applicant_id": app_arr._id,
                            "isAgreementChecked": this.state.isAgreementChecked
                        }
                        app_agreement.push(applicants_Agreement)
                        // console.log(applicants_Agreement.isAgreementChecked)
                        this.setState({ isAgreementChecked: applicants_Agreement.isAgreementChecked })
                    })
                    // console.log(app_agreement)
                    this.setState({ applicantsAgreement: app_agreement })

                })
                .catch(err => {
                    console.log(err);
                })
        }, 1000)
    }

    getApplicantReviewForm = async (app_id) => {
        //console.log(app_id)
        localStorage.setItem("applicant_id", app_id)
        // console.log("before fields load ...");
        this.setState({ showAgreement: false })
        await axios
            .post('/visa/getReviewFormForApplicant', {
                "applicant_id": app_id,
                "name": "visa_form_template",
                "travelling_to_identity": localStorage.getItem('travelling_to_identity')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                console.log(">>>>>>>>", res.data.dataobj);
                this.setState({ reviewForm: res.data.dataobj.visa_form })
                this.setState({ activeItem: app_id })
                var form_obj = {}
                this.state.reviewForm.map((review_form) => {
                    this.setState({ [review_form.name]: review_form.value })
                    form_obj[review_form.name] = review_form.value
                })
                this.setState({ "form_obj": form_obj })
                //console.log(">>>>>>>>>>>>> NEW JSON "+this.state.form_obj)
                // console.log("after fields load ...");
                this.setState({ showAgreement: true })
            })
            .catch(err => {
                console.log(err);
            })
    }

    getApplicantDocData(app_id) {
        //console.log(app_id)
        axios
            .get('/visa/getApplicantDocumentData', {
                params: {
                    application_id: localStorage.getItem('application_id'),
                    applicant_id: app_id
                }
            })
            .then((resp) => {
                //console.log(resp.data.dataobj.applicant_doc.required_documents)
                var req_doc_array = resp.data.dataobj.applicant_doc.required_documents
                var additional_doc_array = resp.data.dataobj.applicant_doc.additional
                var uploaded_additional_doc_array = []
                additional_doc_array.map((items) => {
                    if (items.doc_snap[0].status === 'uploaded') {
                        uploaded_additional_doc_array.push(items)
                    }
                }
                )
                //    console.log(uploaded_additional_doc_array)
                var all_docs = req_doc_array.concat(uploaded_additional_doc_array)

                this.setState({ appDocData: all_docs })
                this.setState({ activeItem: app_id })
                //console.log(resp.data.dataobj.applicant_doc.required_documents)

                var applicant_doc = [];
                var applicantDoc_obj;

                this.state.appDocData.map((items) => {
                    //console.log(items)

                    items.doc_snap.map((doc_snap) => {

                        //console.log(doc_snap.doc_url)
                        if (!doc_snap.doc_url == "") {
                            applicantDoc_obj = {
                                original: doc_snap.doc_url,
                                thumbnail: doc_snap.doc_url,
                                originalClass: "original_image border p-2",
                                thumbnailClass: "thumbnail_imags text-left"
                            }
                        } else {
                            applicantDoc_obj = {}
                        }

                    })

                    applicant_doc.push(applicantDoc_obj)

                    // console.log("ITEMLIST" , applicant_doc);

                    var newApplicant_doc = applicant_doc.filter((value) => Object.keys(value).length !== 0)

                    //console.log(applicant_doc)
                    this.setState({ applicantDoc: newApplicant_doc })

                    // console.log("Items", this.state.applicantDoc);
                })
            })
            .catch(err => {
                console.log(err);
            })
    }
    // images = [

    //       {
    //         original: 'https://picsum.photos/id/1018/1000/600/',
    //         thumbnail: 'https://picsum.photos/id/1018/250/150/',
    //       originalClass : "original_image"

    //       },
    //       {
    //         original: 'https://picsum.photos/id/1015/1000/600/',
    //         thumbnail: 'https://picsum.photos/id/1015/250/150/',
    //       originalClass : "original_image"

    //       },
    //       {
    //         original: 'https://picsum.photos/id/1019/1000/600/',
    //         thumbnail: 'https://picsum.photos/id/1019/250/150/',
    //         originalClass : "original_image"

    //       },
    // ];

    render() {
        if (this.state.isSubmitApplication) {
            return <Redirect to="/payment-details" />
        }
        if (this.state.isMissingDocuments) {
            return <Redirect to="/additional-organize" />
        }

        const reviewForm = () => {
            return <>
                {this.state.imageLoad &&
                    <img src={loader} className="image_loader" />
                }
                <MDBRow >
                    <MDBCol sm="5" style={{ marginTop: '1rem' }}>
                        {/* <MDBCardImage style={{}} className="img-fluid p-3" src={profile_pic}  /> */}

                        <MDBContainer className="width1">
                            <ImageGallery

                                additionalClass="image"
                                items={this.state.applicantDoc}
                                // items={this.images}
                                thumbnailPosition="bottom"
                                showFullscreenButton={false}
                                showPlayButton={false}
                                showNav={false}
                                infinite={false}
                                disableKeyDown={true}
                                // showNav={true}
                                // showBullets={true}
                                // originalClass="image"
                                onImageLoad={() => this.setState({ imageLoad: false })}


                            />
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol sm="7">
                        <MDBContainer fluid>
                            <MDBRow>
                                {this.state.reviewForm.map(this.renderFields)}
                            </MDBRow>
                        </MDBContainer>
                        <MDBContainer fluid>
                            <MDBRow>
                                <MDBCol sm="12">
                                    {this.state.showAgreement &&
                                        <div className="custom-checkbox text-muted" >
                                            <input type="checkbox" checked={this.state.isAgreementChecked} onChange={this.handleAgreementChecked} />
                                        &nbsp;<span>  I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief.</span>
                                        </div>
                                    }
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>
            </>
        }

        if (this.state.toTrackApplication) {
            return <Redirect to="/track-application" />
        }

        return (
            <>
                <div>
                    <h4><b>Apply New Visa</b></h4>
                </div>
                {/* {console.log(this.state.applicantsArr)} */}
                <BasicInfoCard applicantLength={this.state.applicantsArr} />
                {/* <div className="mt-4">
                    <MDBCard>
                    <MDBCardBody>
                            <MDBCardTitle>Basic Information</MDBCardTitle>
                            <hr/>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Country of Residence: </th><td>{this.state.origin}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling To: </th><td>{this.state.travelling_to_country}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Type: </th><td>{this.state.visa_type} | {this.state.entry_type} Entry</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Duration: </th><td>{this.state.visa_duration} Days</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Nationality: </th><td>{this.state.nationality}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Applicants: </th><td>{this.state.applicants}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="4">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling Dates: </th><td>{this.state.arrival_dt} To {this.state.departure_dt}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div> */}
                <div className="mt-4 mb-5">
                    <MDBCard style={{ marginBottom: '10rem' }}>
                        <MDBNav className="nav-tabs">
                            {this.state.applicantsArr.map((applicant_tab, index) =>
                                <>
                                    {/* {applicant_tab.file_type === "passport-front" && */}
                                    <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === applicant_tab._id} onClick={this.toggle(applicant_tab._id)} key={index} role="tab">
                                            {applicant_tab.applicant_first_name} {applicant_tab.applicant_last_name}&nbsp;
                                        <img className="img-fluid icon-actions" style={{ position: 'absolute' }} src={delete_icon} data-toggle="modal" data-target="#deleteApplicantModal" />&nbsp; &nbsp;
                                    </MDBNavLink>
                                    </MDBNavItem>
                                    {/* }                                         */}

                                    <div className="modal fade" id="deleteApplicantModal" tabindex="-1" role="dialog" aria-labelledby="deleteApplicantModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                                        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">

                                                    <h6 className="modal-title" id="deleteApplicantModalLabel"><b>Delete Applicant</b></h6>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <p>Are you sure, you want to delete the applicant ?</p>
                                                </div>
                                                <div className="modal-footer">
                                                    <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }} onClick={() => this.setState({ imageLoad: false })} >Close</MDBBtn>
                                                    <MDBBtn color="none" data-dismiss="modal" onClick={() => { this.handleDeleteApplicantTab(applicant_tab._id) }} style={{ color: 'white', backgroundColor: this.state.brand_color, textTransform: 'none', }}>Delete</MDBBtn>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </MDBNav>
                        {/* {this.state.documents_pool.map((applicant_tab, index) =>  */}
                        <MDBTabContent activeItem={this.state.activeItem}>
                            <MDBTabPane tabId={this.state.activeItem} role="tabpanel">
                                {reviewForm()}
                            </MDBTabPane>
                        </MDBTabContent>
                        {/* )} */}
                    </MDBCard>
                </div>
                {/* <div className="modal fade" id="rejectApplicationModal" tabindex="-1" role="dialog" aria-labelledby="rejectApplicationModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            
                            <h4 className="modal-title" id="rejectApplicationModalLabel"><b>Reject Application</b></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        <small>Application status</small>
                        <Select 
                            id="rejectStatus"
                            style={{ width:'100%',textAlign:'left', padding:0}}  
                            name="rejectStatus"                                              
                            >
                            <MenuItem>Information Required</MenuItem>
                        </Select>
                        <div className='mt-2'>
                        <small>Comments(Optional)</small>
                        <MDBInput type="textarea" label="Enter your comments" rows="1" placeholder="Leave your comments"/>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}}>Close</MDBBtn>
                            <MDBBtn color="none" data-dismiss="modal" onClick={()=>{this.setState({toTrackApplication:true})}} style={{color:'white',backgroundColor:'#673784', textTransform:'none',}}>Submit</MDBBtn>
                        </div>
                    </div>
                </div>
                </div> */}
                {/* <div className="modal fade" id="draftModal" tabindex="-1" role="dialog" aria-labelledby="draftModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            
                            <h4 className="modal-title" id="draftModalLabel"><b>Save as Draft</b></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        <p> some message</p>
                        </div>
                        <div className="modal-footer">
                            <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}}>Close</MDBBtn>
                            <RouterLink to="/track-application">
                                <MDBBtn color="none" data-dismiss="modal" onClick={()=>{this.setState({toTrackApplication:true})}} style={{color:'white',backgroundColor:'#673784', textTransform:'none',}}>Save</MDBBtn>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                </div> */}
                <MDBRow id="footerRow" style={{ width: "100%" }}>
                    <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

                        {/* <MDBContainer> */}
                        <MDBRow>
                            <MDBCol size="12" sm="6" md="6" lg="6" >
                                {
                                    this.state.showReviewFormFieldErr &&
                                    <MDBAlert color='danger'>{this.state.errorTextMsg}</MDBAlert>
                                }
                                {/* {
                                        this.state.isDocDeleted &&
                                        <MDBAlert color='success'>{this.state.deleteDocMessage}</MDBAlert>
                                    } */}
                            </MDBCol>
                            <MDBCol size="12" sm="6" md="6" lg="6" style={{ textAlign: 'right' }}>
                                {/* <RouterLink to="/payment-details"><MDBBtn id="proceedBtn" style={{color:'white',backgroundColor:'#673784',width:'40%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none" onClick={this.handleApplicationProceed}>Proceed</MDBBtn></RouterLink> */}
                                <MDBBtn id="saveBtn" data-toggle="modal" data-target="#draftModal" style={{ color: 'white', backgroundColor: 'black', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none">Save as Draft</MDBBtn>
                                <MDBBtn id="submitApplicationBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={() => this.handleApplicationProceed()}>Submit Application</MDBBtn>
                            </MDBCol>
                        </MDBRow>
                        {/* </MDBContainer> */}
                    </MDBFooter>
                </MDBRow>


                {/* <MDBModal centered isOpen={this.state.expiryDate} toggle={this.applicantAgreementCheckToggle}>
                <MDBModalHeader toggle={this.applicantAgreementCheckToggle}>User Agreements</MDBModalHeader>
                    <MDBModalBody>
                        <>
                            <h6>Your Passport has expired.Please upload valid passport.</h6>
                        </>                               
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="dark" style = {{textTransform:'none'}} onClick={this.applicantAgreementCheckToggle}>Ok</MDBBtn>            
                    </MDBModalFooter>
                </MDBModal> */}

                <MDBModal centered isOpen={this.state.isNotAllChecked} toggle={this.applicantAgreementCheckToggle}>
                    <MDBModalHeader toggle={this.applicantAgreementCheckToggle}>User Agreements</MDBModalHeader>
                    <MDBModalBody>
                        <>
                            <h6>Please accept agreements for all applicants !!</h6>
                        </>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.applicantAgreementCheckToggle}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                {/* {this.state.expiryDate && */}
                <MDBModal centered isOpen={this.state.expiryDate} toggle={this.validPassportModal}>
                    <MDBModalHeader toggle={this.validPassportModal}>User Agreements</MDBModalHeader>
                    <MDBModalBody>
                        <>
                            <h6>Your Passport has expired.</h6>
                        </>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.validPassportModal}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                {/* } */}


                <MDBModal centered isOpen={this.state.showMissingFieldModal} toggle={this.missingFieldToggle}>
                    <MDBModalHeader toggle={this.missingFieldToggle}>Following field values are invalid or missing</MDBModalHeader>
                    <MDBModalBody>
                        <>

                            {this.state.applicantsMissingFields.map((fields) =>
                                //<h6>{fields.applicant_name}</h6>
                                <>
                                    <h6>{fields.applicant_name}</h6>

                                    <ul>
                                        {
                                            fields.missing_fields.map((m) =>
                                                <li>{m}</li>
                                            )
                                        }
                                    </ul>
                                </>
                            )}
                        </>

                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.missingFieldToggle}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal centered isOpen={this.state.showMissingDocModal} toggle={this.missingDocToggle}>
                    <MDBModalHeader toggle={this.missingDocToggle}><h5 className="mb-0">Additional Documents Required</h5></MDBModalHeader>
                    <MDBModalBody>
                        <>
                            {/* <h8>{this.state.missingData}</h8> */}
                            {this.state.missingDocData.map((fields) =>
                                <li>
                                    {fields}
                                </li>
                            )}
                        </>

                    </MDBModalBody>
                    <MDBModalFooter>
                        {/* <MDBBtn color='white' style = {{textTransform:'none'}} onClick={this.missingDocToggle}>Cancel</MDBBtn> */}
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.handle_missing_doc_ok}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <div className="modal fade" id="draftModal" tabindex="-1" role="dialog" aria-labelledby="draftModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h6 className="modal-title" id="draftModalLabel"><b>Save as Draft</b></h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>We will save your information and documents. You can resume anytime from 'Track Application'.</p>
                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                                <MDBBtn color="none" data-dismiss="modal" onClick={() => this.handleReviewFormSave()} style={{ color: 'white', backgroundColor: this.state.brand_color, textTransform: 'none', }}>Save</MDBBtn>
                                {/* </RouterLink> */}
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )
    }
}

export default ReviewApplicaton;
